// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--3s-E_";
export var content = "contact-module--content--3BO-w";
export var header = "contact-module--header--u5e5U";
export var emails = "contact-module--emails--1jDCX";
export var socialIcons = "contact-module--socialIcons--1WAFP";
export var address = "contact-module--address--1xj9r";